import classNames from "classnames"
import { motion } from "framer-motion"
import PropTypes from "prop-types"
import React from "react"

import Tile from "../../tile/tile"
import "./section-with-image.sass"

export function getPlainText(children) {
  let text = ""
  React.Children.forEach(children, (child) => {
    // If the child is simply a string, add it directly.

    if (typeof child === "string") {
      text += " " + child
    }
    // If the child is a valid React element, recurse through its children.
    else if (React.isValidElement(child)) {
      text += getPlainText(child.props.children)
    }
    // Otherwise, the child might be something else (like a number or fragment).
    else if (typeof child === "number") {
      text += child
    }
    // You could add more conditions here if your use case requires it,
    // e.g. for booleans, undefined, null, or fragments.
  })
  return text
}

const SectionWithImage = ({
  children,
  imagePath,
  textSide,
  imageTop,
  limitImageHeight,
  center,
  smallMinImageHeight,
  sectionTitle,
}) => {
  return (
    <motion.div layout>
      <Tile>
        <div
          className={classNames("_fp-section-with-image", {
            "_fp-section-with-image--right": textSide === "right",
            "_fp-section-with-image--image-top": imageTop,
            "_fp-section-with-image--limit-image-height": limitImageHeight,
            "_fp-section-with-image--small-min-image-height":
              smallMinImageHeight,
            "_fp-section-with-image--center": center,
          })}
        >
          {sectionTitle && (
            <div className={"_fp-section-with-image__title"}>
              <h3 className={"_fp-heading-1"}>{sectionTitle}</h3>
            </div>
          )}
          <div className={"_fp-section-with-image__content"}>
            <div
              className={classNames("_fp-section-with-image__content__text")}
            >
              {children}
            </div>

            <div className={"_fp-section-with-image__content__image"}>
              <motion.img src={imagePath} alt={getPlainText(children)} />
            </div>
          </div>
        </div>
      </Tile>
    </motion.div>
  )
}

SectionWithImage.propTypes = {
  imagePath: PropTypes.string,
  imageTop: PropTypes.bool,
  textSide: PropTypes.oneOf(["left", "right"]),
  center: PropTypes.bool,
}

SectionWithImage.defaultProps = {
  textSide: "left",
  center: false,
}

export default SectionWithImage
